<template>
  <div>
    <a-tabs default-active-key="1" @change="tabChange">
      <a-tab-pane
        v-for="t in courseTypes"
        :key="t.value"
        :tab="t.title"
      >
        <a-spin tip="Loading..." :spinning="spinningCourse[t.value]">
          <a-row v-if="t.value in courseResult">
            <a-col
              :span="8"
              v-for="(item, index) in courseResult[t.value]"
              :key="index"
            >
              <a-card>
                <div slot="cover" @click="toUnitList(item.id)">
                  <img :src="item.courseCover_url" />
                </div>
                <div>
                  <h3>{{ item.courseName }}</h3>
                  <p style="color: #999;font-size: 12px;">班级：{{item.departName}}</p>
                  <a-tooltip placement="bottomRight">
                    <template slot="title">
                      <span>进度:{{item.startedUnit}}/{{item.totalUnit}}</span>
                    </template>
                    <a-progress
                    status="active"
                    :show-info="false"
                    :percent="item.startedUnit / item.totalUnit"/>
                  </a-tooltip>
                </div>
                <template slot="actions" class="ant-card-actions">
                  <a-button v-if="item.openMethod==1 || item.openMethod==2&&item.openTime>item.serverTime" style="border-radius: 50px;width:90%;" type="primary" @click="toUnitList(item)"
                    >去上课</a-button
                  >
                  <a-button v-else style="border-radius: 50px;width:90%;" type="default"
                    >{{item.openMethod==2&&item.openTime?item.openTime+'开课':'未开课'}}</a-button
                  >
                </template>
              </a-card>
            </a-col>
          </a-row>
        </a-spin>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import { getMineCourse, getNewCourse } from "@/api/course";
import { getDict } from "@/api/sys";
export default {
  name: "StudentCourse",
  data() {
    return {
      courseTypes: [],
      spinningCourse: {},
      courseResult: {},
    };
  },
  created() {
    this.getCourseType();
    this.getMineCourse(1);
  },
  methods: {
    tabChange(activeKey) {
      this.getMineCourse(activeKey);
    },
    getCourseType() {
      getDict("course_type").then((res) => {
        if (res.success) {
          this.courseTypes = res.result;
        }
      });
    },
    getMineCourse(courseType) {
      Vue.set(this.spinningCourse, courseType, true)
      this.spinningCourse[courseType] = true
      getMineCourse({courseType: courseType}).then((res) => {
        Vue.set(this.spinningCourse, courseType, false)
        if (res.success) {
          this.courseResult[courseType] = res.result;
        }
      });
    },
    toUnitList(item) {
      this.$router.push({
        name: "studentCourseUnit",
        query: { courseId: item.id, departId: item.departId },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.ant-card{
  margin: 10px;
  .ant-card-cover{
    img{
      width: 100%;
    }
  }
}
.ant-tabs-tabpane{
  text-align: center;
}
</style>